import React from 'react'
import Question from './Question'
import Answers from './Answers'

const Questions = (props) => {
    


 
    return (
       
        <div>
       
       <div>
   <Question question={props.question} option1={props.option1} option2={props.option2} option3={props.option3} option4={props.option4} answer={props.answer} />
        </div>

        <div>

<Answers option1={props.option1} option2={props.option2} option3={props.option3} option4={props.option4} answer={props.answer} answerCheck={props.answerCheck} />

        </div>

        </div>
    )
}

export default Questions
